import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/exam";
import { enRouteOptions } from "@/lib/route-i18n";

export const Route = createFileRoute("/en/exam")(
  enRouteOptions(routeOptions, {
    svPath: "/exam",
    title: 'Mock Exam – Swedish Alcohol Serving Licence Test',
    description: 'Take a timed mock exam that mirrors the real Swedish kunskapsprov: 60 questions, 30 minutes, pass limits per topic.',
    ogImage: "https://alkoholprovet.se/og/default.jpg",
    noindex: false,
  }),
);
